import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-fa73e16e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "box"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "安装信息", -1));
const _hoisted_3 = {
  class: "activity"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "活动", -1));
const _hoisted_5 = {
  class: "cl7c7c7c"
};
const _hoisted_6 = {
  class: "activity vendor"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "供应商", -1));
const _hoisted_8 = {
  class: "cl7c7c7c"
};
const _hoisted_9 = {
  class: "storeBox"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "门店", -1));
const _hoisted_11 = {
  class: "location"
};
const _hoisted_12 = {
  class: "imgUp"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "照片墙", -1));
const _hoisted_14 = ["src"];
const _hoisted_15 = {
  key: 0,
  style: {
    "position": "absolute",
    "right": "-15px",
    "top": "-6px",
    "width": "40px",
    "height": "24px",
    "background": "var(--el-color-error)",
    "text-align": "center",
    "transform": "rotate(45deg)"
  }
};
const _hoisted_16 = {
  key: 1,
  style: {
    "position": "absolute",
    "right": "-15px",
    "top": "-6px",
    "width": "40px",
    "height": "24px",
    "background": "var(--el-color-success)",
    "text-align": "center",
    "transform": "rotate(45deg)"
  }
};
const _hoisted_17 = {
  class: "el-upload-list__item-actions"
};
const _hoisted_18 = ["onClick"];
const _hoisted_19 = ["onClick"];
const _hoisted_20 = ["src"];
const _hoisted_21 = {
  class: "btnBox"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_vxe_option = _resolveComponent("vxe-option");
  const _component_vxe_select = _resolveComponent("vxe-select");
  const _component_Plus = _resolveComponent("Plus");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_Close = _resolveComponent("Close");
  const _component_Check = _resolveComponent("Check");
  const _component_zoom_in = _resolveComponent("zoom-in");
  const _component_Delete = _resolveComponent("Delete");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_el_button = _resolveComponent("el-button");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("span", _hoisted_5, _toDisplayString($setup.ActivityName), 1)]), _createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("span", _hoisted_8, _toDisplayString($setup.vendorName), 1)]), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createVNode(_component_vxe_select, {
    modelValue: $setup.storeCodeSelect,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.storeCodeSelect = $event),
    filterable: "",
    placeholder: "店铺名称",
    size: "medium",
    class: "long-select-store",
    style: {
      "flex": "1",
      "margin-left": "5px"
    },
    onChange: $setup.storeSelectChange
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.storeData, item => {
      return _openBlock(), _createBlock(_component_vxe_option, {
        label: item.label,
        value: item.value,
        key: item.value
      }, null, 8, ["label", "value"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue", "onChange"])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.demo, (x, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "imgBox",
      key: index
    }, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", null, _toDisplayString(x.locationInfo), 1), _createElementVNode("div", null, _toDisplayString($setup.getInstallName(x.installationStatusId)), 1)]), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("div", null, [_createVNode(_component_el_upload, {
      "file-list": $setup.uploadTableData[index].fileList,
      "onUpdate:fileList": $event => $setup.uploadTableData[index].fileList = $event,
      "list-type": "picture-card",
      limit: $setup.maxNum,
      ref_for: true,
      ref: "uploadTable",
      multiple: "",
      action: $setup.uploadTableData[index].signatureData.host,
      "before-upload": file => {
        return $setup.handleBefore(file, index);
      },
      "on-success": (response, file, fileList) => {
        return $setup.handleStoreOnSuccess(response, file, fileList, index);
      },
      data: $setup.uploadTableData[index].data,
      "on-exceed": $setup.handleExceed,
      "before-remove": (file, fileList) => {
        return $setup.onBeforeRemove(file, fileList, index);
      },
      "on-remove": $setup.onRemove,
      "on-preview": $setup.handlePictureCardPreview,
      class: _normalizeClass({
        reached_the_limit: $setup.getDisabledAdd(x, index)
      }),
      accept: "image/*"
    }, {
      file: _withCtx(({
        file
      }) => [_createElementVNode("div", null, [_createElementVNode("img", {
        class: "el-upload-list__item-thumbnail",
        src: file.url,
        alt: ""
      }, null, 8, _hoisted_14), file.activityInstallationUploadStatusId == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createVNode(_component_el_icon, {
        style: {
          "color": "#fff",
          "font-size": "12px",
          "margin-top": "11px",
          "transform": "rotate(-45deg)"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_Close)]),
        _: 1
      })])) : _createCommentVNode("", true), file.activityInstallationUploadStatusId == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createVNode(_component_el_icon, {
        style: {
          "color": "#fff",
          "font-size": "12px",
          "margin-top": "11px",
          "transform": "rotate(-45deg)"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_Check)]),
        _: 1
      })])) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_17, [_createElementVNode("span", {
        class: "el-upload-list__item-preview",
        onClick: $event => $setup.handlePictureCardPreview(file)
      }, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_zoom_in)]),
        _: 1
      })], 8, _hoisted_18), file.installationStatusId != 5 || file.activityInstallationUploadStatusId == 3 ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: "el-upload-list__item-delete",
        onClick: $event => $setup.onBeforeRemove(file, _ctx.fileList, index)
      }, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_Delete)]),
        _: 1
      })], 8, _hoisted_19)) : _createCommentVNode("", true)])])]),
      default: _withCtx(() => [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_Plus)]),
        _: 1
      })]),
      _: 2
    }, 1032, ["file-list", "onUpdate:fileList", "limit", "action", "before-upload", "on-success", "data", "on-exceed", "before-remove", "on-remove", "on-preview", "class"])])])]);
  }), 128)), _createVNode(_component_el_dialog, {
    modelValue: $setup.dialogVisible,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $setup.dialogVisible = $event),
    class: "preViewBox",
    style: {
      "width": "90vw",
      "height": "auto",
      "margin-top": "20vh"
    }
  }, {
    default: _withCtx(() => [_createElementVNode("img", {
      "w-full": "",
      src: $setup.dialogImageUrl,
      alt: "Preview Image",
      style: {
        "width": "100%"
      }
    }, null, 8, _hoisted_20)]),
    _: 1
  }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_21, [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
    class: "defaultBtn",
    color: "#000",
    onClick: $setup.sumbitStoreLocation
  }, {
    default: _withCtx(() => [_createTextVNode("下一步")]),
    _: 1
  }, 8, ["onClick"])), [[_directive_loading, $setup.fullscreenLoading, void 0, {
    fullscreen: true,
    lock: true
  }]]), _createVNode(_component_el_button, {
    class: "defaultBtn",
    onClick: _cache[2] || (_cache[2] = $event => $setup.router.go(-1))
  }, {
    default: _withCtx(() => [_createTextVNode("取消")]),
    _: 1
  })])]);
}